var gElem = ".quote_wrapper.full .container";
var g_is_ie = 0;

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(() => {
        site_documentReady();
    }, 250)
});

$(window).on("load", function () {
    fadeInPics();
    if ($(gElem)) {
        $(gElem).animate({
            opacity: 1
        }, 350);
    }
});

function site_documentReady() {
    var siteKey = "6Le1XMEZAAAAAH4ScUO9vwt5Vmeyg6p3hM1qYQUt";


    // FRANCIS: Hide images we want to preload
    $('.preload:not(.slick-cloned),' + gElem)
        .addClass('is-preloading')
        .css('opacity', 0);

    // FRANCIS: Jquery Transit fallback on no support
    if (!$.support.transition) {
        $.fn.transition = $.fn.animate;
    }

    //SEB: Head quote (homepage)
    $(window).scroll(function () {
        if ($(gElem).length > 0) {
            if ($(window).width() >= 1024) {
                //Fading quote
                if ($(window).scrollTop() >= $('header').height() * 2.5) {
                    $(gElem).fadeOut(300);
                    $('.scroll_trigger').fadeOut(300);
                } else {
                    $(gElem).fadeIn(300);
                    $('.scroll_trigger').fadeIn(300);
                }
            }
        }
    });

    // SEB: Projects scroll-to trigger
    $(document).keydown(function (e) {
        if (e.keyCode == 40) {
            scrollToProjects();
            return false;
        }
    });
    $('.scroll_trigger').click(function () {
        scrollToProjects();
    });

    function scrollToProjects() {
        $('html, body').animate({
            scrollTop: $('#projects').offset().top
        }, 300);
    }


    // SEB : Data display for fake file input
    $('input[type="file"]').change(function () {
        var value = $(this).val()
        value = value.replace(/C:\\fakepath\\/i, '');
        $(this).siblings('.fake').children('.text').text(value);
    });

    // SEB : Form js validation
    var form = $("#frm_contact, #frm_careers");

    $(".submit").on("click", function(event) {
        event.preventDefault();
        if ($(".career-form").valid()) {
            grecaptcha.ready(function() {
                grecaptcha.execute(siteKey, {action: 'submit'}).then(function(token) {
                    var formElem = document.querySelector('.career-form');
                    var input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', 'g-recaptcha-response');
                    input.setAttribute('value', token);
                    formElem.appendChild(input);

                    // Now submit the form
                    formElem.submit();
                });
            });
        } else {
            return false;
        }
    });

    jQuery.validator.addMethod("caPhoneNumber", function (value, element) {
        return this.optional(element) || value.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
    });

    $(form).validate({
        onkeyup: function (element) {
            $(element).valid();
        },
        rules: {
            email: {
                email: true
            },
            phone: {
                caPhoneNumber: true
            }
        },
        submitHandler: function (form) {
            },
        errorPlacement: function (error, element) { }
    });

    // ALEXE : x close confirmation window
    $('.x_close, .overlay').click(function () {
        $('.wrapper_lightbox_confirm').fadeOut(300, function () { });
    });

    // SEB: Handle orientation changes
    var $win = $(window).bind('orientationchange', function () {
        $('body').removeClass('landscape portrait') // reset
            .addClass(Math.abs(this.orientation) === 90 ? "landscape" : "portrait");
    });

    $win.trigger('orientationchange');

    //Checking if IE8
    if ($('html').hasClass('lt-ie9')) {
        g_is_ie = 1;
    }
}

function fadeInPics() {
    $('.preload').each(function (index) {
        $(this).removeClass('is-preloading').delay(index * 50).animate({
            opacity: '1'
        }, 300);
    })
}
